export function formatValue(value) {
  const formattedValue = parseFloat(value).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
  });
  return formattedValue;
}
